"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
class LocaleService {
  constructor(_ref) {
    let {
      i18n,
      options
    } = _ref;
    this.i18n = void 0;
    this.i18n = i18n;
    this.localeString = this.localeString.bind(this);
    this.formatPrice = this.formatPrice.bind(this);
    this.options = options;
  }

  /**
   * Retrieves the market price format pattern based on the current market.
   *
   * @param {string} price - The price format pattern to be used.
   * @returns {string} The market price format pattern for the current market.
   */
  getMarketPriceFormatPattern(price) {
    const MARKET_PRICE_FORMAT_PATTERNS = {
      de: price
    };
    return MARKET_PRICE_FORMAT_PATTERNS[this.options.market];
  }
  localeString(key) {
    let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    if (!this.i18n) {
      return key;
    }
    const marketTranslation = this.i18n(`${this.options.market}.${key}`, options);
    const translation = this.i18n(key, options);
    const finalTranslation = marketTranslation.includes(key) || key.includes(marketTranslation) ? translation : marketTranslation;
    if ((finalTranslation.includes(key) || key.includes(finalTranslation)) && options.allowMissingKey) {
      return null;
    }
    return finalTranslation || key;
  }

  /**
   * price specific parsing
   * @param input {string}
   * @returns {string}
   */
  addThousandsSeparators(input) {
    const str = String(input).trim();
    let numStr = '';
    let prefix = '';
    let decimalPart = '';
    for (const element of str) {
      const char = element;
      if (/[0-9.,]/.test(char)) {
        numStr += char;
      } else if (numStr === '') {
        prefix += char;
      } else {
        return input;
      }
    }
    numStr = numStr.replace(/,/g, '');
    const decimalIndex = numStr.indexOf('.');
    if (decimalIndex !== -1) {
      decimalPart = numStr.slice(decimalIndex);
      numStr = numStr.slice(0, decimalIndex);
    }
    let formattedNumStr = '';
    let count = 0;
    // adding comma separator after each 3 numbers
    for (let i = numStr.length - 1; i >= 0; i--) {
      formattedNumStr = numStr[i] + (count > 0 && count % 3 === 0 ? ',' : '') + formattedNumStr;
      count++;
    }
    return prefix + formattedNumStr + decimalPart;
  }
  /**
   * Currency specific parsing
   * @param price {string}
   * @param currency {string}
   * @returns {string}
   */
  parsePrice(price, currency) {
    var _this$getMarketPriceF;
    switch (currency) {
      case 'EUR':
        return (_this$getMarketPriceF = this.getMarketPriceFormatPattern(price)) !== null && _this$getMarketPriceF !== void 0 ? _this$getMarketPriceF : price.replace(/\s/, '');
      case 'USD':
        {
          const formattedPrice = price.replace('US', '').trim();
          const digits = formattedPrice.replace(/[^\d.,]/g, '');
          const currencyPart = formattedPrice.replace(/[\d.,]/g, '').trim();
          return currencyPart + digits;
        }
      case 'ZAR':
        return this.addThousandsSeparators(price.replace(/\s+/g, '').replace('ZAR', 'R'));
      case 'PEN':
        {
          let formattedPrice = price.replace(/\s+/g, '').replace(/(.)(?=(\d{3}))/g, ',') // replace . by comma for 3 digits followed by .
          .replace(/((,)(?=(\d{2})))+(?!\d{3})/g, '.'); // replace comma by . for 2 digits followed by ,

          const currencyIndex = formattedPrice.search(/[a-zA-Z]/);
          if (currencyIndex !== -1) {
            const numberPart = formattedPrice.slice(0, currencyIndex).trim();
            const currencyPart = formattedPrice.slice(currencyIndex).trim();
            formattedPrice = `${currencyPart} ${numberPart}`;
          }
          formattedPrice = formattedPrice.replace('PEN', 'S/').replace('.00', '');
          return formattedPrice;
        }
      default:
        return price;
    }
  }
  formatPrice(amount) {
    var _this$localeString;
    let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    const locale = this.localeString('locale');
    const currency = (_this$localeString = this.localeString('currency', {
      allowMissingKey: true
    })) !== null && _this$localeString !== void 0 ? _this$localeString : 'USD';
    const {
      maximumFractionDigits,
      minimumFractionDigits
    } = {
      ...this.options,
      ...options
    };
    const formatOptions = {
      style: 'currency',
      currency,
      maximumFractionDigits,
      minimumFractionDigits
    };
    const formatter = new Intl.NumberFormat(locale, formatOptions);
    const formattedPrice = formatter.format(amount);
    return this.parsePrice(formattedPrice, currency);
  }
}
var _default = LocaleService;
exports.default = _default;